// Flag levels - BETA includes FLOATS
export const FLAG_LEVELS = {
  FLOATS: "FLOATS",
  BETA: "BETA",
};

// Configuration from environment
const config = {
  FLOATS: {
    domains: (process.env.NEXT_PUBLIC_FF_FLOATS_DOMAINS || "")
      .split(",")
      .filter(Boolean),
    userIds: (process.env.NEXT_PUBLIC_FF_FLOATS_USER_IDS || "")
      .split(",")
      .filter(Boolean),
  },
  BETA: {
    domains: (process.env.NEXT_PUBLIC_FF_BETA_DOMAINS || "")
      .split(",")
      .filter(Boolean),
    userIds: (process.env.NEXT_PUBLIC_FF_BETA_USER_IDS || "")
      .split(",")
      .filter(Boolean),
  },
};

/**
 * Check if a user has access to a specific flag level
 * @param {string} flagLevel - FLAG_LEVELS.FLOATS or FLAG_LEVELS.BETA
 * @param {{ email?: string, id?: string | number }} user - User object with email and/or id
 * @returns {boolean}
 */
export function hasFeatureAccess(flagLevel, user) {
  if (!user) return false;

  const email = user.email;
  const userId = user.id?.toString();
  const emailDomain = email?.split("@")[1]?.toLowerCase();

  // Check direct access to the requested level
  const checkLevel = (level) => {
    const levelConfig = config[level];
    if (!levelConfig) return false;

    // Check domain match
    if (
      emailDomain &&
      levelConfig.domains.some((d) => d.toLowerCase() === emailDomain)
    ) {
      return true;
    }

    // Check user ID match
    if (userId && levelConfig.userIds.includes(userId)) {
      return true;
    }

    return false;
  };

  // BETA includes FLOATS access
  if (flagLevel === FLAG_LEVELS.BETA) {
    return checkLevel(FLAG_LEVELS.FLOATS) || checkLevel(FLAG_LEVELS.BETA);
  }

  // BETA only
  return checkLevel(FLAG_LEVELS.FLOATS);
}

/**
 * Get all flag levels a user has access to
 * @param {{ email?: string, id?: string | number }} user
 * @returns {string[]}
 */
export function getUserFlagLevels(user) {
  const levels = [];
  if (hasFeatureAccess(FLAG_LEVELS.FLOATS, user))
    levels.push(FLAG_LEVELS.FLOATS);
  if (hasFeatureAccess(FLAG_LEVELS.BETA, user)) levels.push(FLAG_LEVELS.BETA);
  return levels;
}
